import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";

/**
 * Credit score related actions/action creators
 */
import nwApiSDK from '@nerdwallet/nw-api-sdk'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import get from 'lodash/get'; // Requires having process.env.CLIENT_ID and process.env.IDENTITY_BASE_URL
// variables so we can instantiate IdentitySDK

var _nwApiSDK = nwApiSDK({
  clientID: process.env.CLIENT_ID,
  applicationID: 'nerdwallet web',
  identityBaseUrl: process.env.IDENTITY_BASE_URL
}),
    IdentitySDK = _nwApiSDK.IdentitySDK;

var log = function log(req, level) {
  if (req && req.log && req.log[level]) {
    var _req$log;

    for (var _len = arguments.length, message = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      message[_key - 2] = arguments[_key];
    }

    (_req$log = req.log)[level].apply(_req$log, message);
  }
}; // Action to return credit score


export var RECEIVE_CREDIT_SCORE = 'RECEIVE_CREDIT_SCORE';
export var fetchCreditScore = function fetchCreditScore(serverRequest, serverResponse) {
  return function (dispatch, getState) {
    // Bail if we aren't logged in
    var hasIdentityId = get(serverResponse, 'locals.data.IdentityStore.currentIdentity.id');

    if (!hasIdentityId && !get(getState(), 'identity.id')) {
      return Promise.resolve();
    }

    return IdentitySDK.TUCreditReport.getCreditScore(serverRequest).then(function () {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (data.vantage_score_3) {
        dispatch({
          type: RECEIVE_CREDIT_SCORE,
          creditScore: data.vantage_score_3
        });
      }
    }).catch(function (e) {
      var error = get(e, 'data.error') || {}; // Ignore NotFoundError, as that is the expected response for users without a TUProfile.

      if (error.type !== 'NotFoundError') {
        log(serverRequest, 'error', error, 'error fetching credit score');
      }
    });
  };
};